import React, { useState } from 'react'
import { useMount } from 'ahooks'
import { Toast } from 'antd-mobile'
import symbols from 'virtual:svg-icons-names'
import utils from '@/utils/utils'
import Icon from '@/components/Icon/Icon'
import styles from './index.module.less'

const { copyToClipboard } = utils

const SvgPreview: React.FC = () => {
  const [icons, setIcons] = useState<string[]>([])

  const copy = (name: string) => {
    copyToClipboard(`<Icon name="${name}" size="48" color="black" />`)

    Toast.show({
      icon: 'success',
      content: '图标已复制',
    })
  }

  useMount(() => {
    const newIcons = symbols.map((item: string) => item.replace('icon-', ''))

    setIcons(newIcons)
  })

  return (
    <div className={styles['wrap']}>
      <div className={styles['svg']}>
        {icons.map((item, index) => {
          return (
            <div className={styles['svg-item']} key={index}>
              <Icon
                className={styles['svg-icon']}
                name={item}
                size="48"
                color="orange"
                onClick={() => copy(item)}
              />

              <span className={styles['svg-name']}>{item}</span>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default SvgPreview
